import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';

export default class GetRefundedNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return '';
  }

  href() {
    return '#';
  }

  content() {
    const notification = this.attrs.notification;
    let money = notification.content();
    return app.translator.trans('dl-pay.forum.operation.refund_notice_text', {money:money});

  }
}
